module.exports = __webpack_public_path__ + "static/img/poster4.b0e09a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poster4.jpg
// module id = /Juy
// module chunks = 1